// The environment variables below are replaced at build time with placeholders.
// These placeholders are then replaced at runtime through the `nginx/run.sh` script.
// The `use` function might seem useless, but without it rollup will replace static
// expressions with whatever the expression evaluates to at build time.
function use<T = string>(envValue: string, defaultValue: T) {
  return envValue || defaultValue
}

// build info
export const version = use(import.meta.env.VUE_APP_VERSION, 'unknown')
export const release = `dashboard@${version}`

// runtime environment
export const environment = use(import.meta.env.VUE_APP_ENVIRONMENT, 'unknown')
export const defaultLocale = use(import.meta.env.VUE_APP_DEFAULT_LOCALE, 'de')

export const sentryDSN = use(import.meta.env.VUE_APP_SENTRY_DSN, null)

export const origin = use(import.meta.env.VUE_APP_ORIGIN, location.origin)

export const mediaStoreAPIRoot = use(import.meta.env.VUE_APP_API_MEDIA_STORE, `${origin}/battery/media-store/api/v2`)
export const steeringOrigin = use(import.meta.env.VUE_APP_STEERING, `${origin}/steering`)
export const steeringAPIRoot = use(import.meta.env.VUE_APP_API_STEERING, `${steeringOrigin}/api/v1`)

export const oidcUrl = use(import.meta.env.VUE_APP_API_STEERING_OIDC_URI, `${steeringOrigin}/openid/`)
export const oidcClientId = use(import.meta.env.VUE_APP_OIDC_CLIENT_ID, undefined) as string
export const oidcRedirectUrl = use(import.meta.env.VUE_APP_API_STEERING_OIDC_REDIRECT_URI, `${origin}/oidc_callback.html`)
export const oidcSilentRedirectUrl = use(import.meta.env.VUE_APP_API_STEERING_OIDC_REDIRECT_URI_SILENT, `${origin}/oidc_callback_silentRenew.html`)
export const oidcExpireNotification = parseInt(use(import.meta.env.VUE_APP_API_STEERING_OIDC_EXPIRE_NOTIFICATION, '120'))
export const oidcPostLogoutRedirectUrl = use(import.meta.env.VUE_APP_API_STEERING_OIDC_REDIRECT_URI_POSTLOGOUT, origin)

export const licenseHelpPage = use(import.meta.env.VUE_APP_LICENSE_HELP_PAGE, 'https://creativecommons.org/share-your-work/cclicenses/')
